import { render, staticRenderFns } from "./patients.vue?vue&type=template&id=7c0add25&scoped=true&"
import script from "./patients.vue?vue&type=script&lang=js&"
export * from "./patients.vue?vue&type=script&lang=js&"
import style0 from "./patients.vue?vue&type=style&index=0&id=7c0add25&prod&lang=scss&scoped=true&"
import style1 from "./patients.vue?vue&type=style&index=1&id=7c0add25&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c0add25",
  null
  
)

export default component.exports